import React from 'react';
import {Card, CardContent, Typography} from "@material-ui/core";

const AboutUsInfo3 = () => {
  return (
    <Card elevation={4}>
      <CardContent>
        <div>
          <Typography variant="body1" component="span">It is because of my mother’s </Typography>
          <Typography variant="h4" component="span"> never-ending love and support </Typography>
          <Typography variant="body1" component="span">
            that my husband Israel and I have chosen to help her achieve her dreams of owning a restaurant.
            Our family has never been more united than we are currently. Therefore, we ask of our community to open their arms to our
            family and join us in celebrating this joyous milestone. Please help us make my mother’s dream
            come true and shine bright.
          </Typography>
          <Typography style={{ paddingTop: '20px', paddingLeft: '20px' }}>
            Thank You! <br />
            Sincerely, <br />
          </Typography>
          <Typography style={{ paddingLeft: '40px' }}>
            Mary C. Castañeda-Santana <br />
            Israel &amp; Minerva Avila <br />
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default AboutUsInfo3;
